import React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useStyles } from '../Interfaces.style';
import RisServers from './RisServers';

const RisInterfaces = ({ setReportRulesChanged }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Typography
        variant='h6'
        color='primary'
        className={`${classes.titleSettingsCard} ${classes.title_margin}`}
      >
        {t('Settings.ris_interfaces')}
      </Typography>

      <RisServers setReportRulesChanged={setReportRulesChanged} />
    </>
  );
};

export default RisInterfaces;
